<template>
  <div class="utility-buttons-wrapper py-26 px-16 border border-1 border-end-0 border-start-0 border-bottom-0" >
    <div class="utility-buttons-inner d-flex align-items-center justify-content-between">
      <label class="label fs-12">{{ title || label }}</label>
      <div class="toggle-button d-flex align-items-center">
        <label class="switch position-relative d-inline-block">
          <input
              v-model="isToggled"
              class="h-0 w-0"
              type="checkbox"
              @change="toggleHandler"
              @click="handleClick">
          <span class="slider round border border-1  border-dark-gray position-absolute "/>
        </label>
      </div>
    </div>

  </div>
</template>
<script>
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';

export default {
  name: 'UtilityButtonsPanel',
  props: {
    label: String,
    title: String,
    id: {String, Number},
    isToggled: {type: Boolean, default: false},
    isSameDimensionPages: {type: Boolean, default: false},

    productHasVideoAudioAnimation: {type: Boolean, default: false},
  },
  data() {
    return {};
  },
  mounted() {
    EventBus.$on('resetToggleButton', this.resetToggle);
  },
  destroyed() {
    EventBus.$off('resetToggleButton', this.resetToggle);
  },
  methods: {
    resetToggle() {
      this.isToggled = false;
    },
    toggleHandler() {
      if (this.label === 'Crop Marks') {
        EventBus.$emit('changeProductAllowCropping', !this.isToggled);
      } else if (this.label === 'Alignment Guides:') {
        EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.PRODUCT_ALIGNMENT_GUIDE);
      } else if (this.label === 'Grayscale PDF:') {
        EventBus.$emit('toggleGrayScale');
      } else if (this.label === 'Show Rulers:') {
        EventBus.$emit('toggleRuler');
      } else if (this.label === 'Video Mode:') {
        if (this.$store.getters['activeProduct/getIsVideoMoodOn']) {
          if (!this.productHasVideoAudioAnimation) {
            this.$store.commit('activeProduct/updateIsVideoMoodOn', false);
            EventBus.$emit(ApplicationEventTypes.Video.ToggleVideoMood, false);
            EventBus.$emit(ApplicationEventTypes.Product.RESET_PRODUCT_THUMBNAILS_DURATION_WIDTH);
          } else {
            this.$store.commit('activeProduct/updateIsVideoMoodOn', true);
            EventBus.$emit(ApplicationEventTypes.ModalEvents.TOGGLE_CONFIRMATION_MODAL, {
              request: 'VideoDisableError',
              title:   'Warning: Disabling Video Mode',
              message: 'Video mode cannot be disabled with video elements on the canvas. Please remove all videos, animations, and audio before disabling.',
            });
          }
        } else if (this.isSameDimensionPages) {
          this.$store.commit('activeProduct/updateIsVideoMoodOn', true);
          EventBus.$emit(ApplicationEventTypes.Video.ToggleVideoMood, true);
        } else {
          EventBus.$emit(ApplicationEventTypes.ModalEvents.TOGGLE_CONFIRMATION_MODAL, {
            request: 'VideoEnableWarning',
            title:   'Warning: Enabling Video Mode',
            message: 'You are attempting to enable video mode, but your current project has pages of different sizes. If you proceed, all pages will be automatically resized to match page 1, which could cause unexpected layout changes or distortion. There is no way to undo this action, so we recommend saving your order before proceeding.',
          });
        }
      }
    },
    handleClick(event) {
      if (this.label === 'Video Mode:' && this.productHasVideoAudioAnimation) {
        event.preventDefault(); // Prevent the default action of the checkbox
        this.toggleHandler(); // Call the toggleHandler method to handle the click event
      }
    }
  }
};

</script>
<style lang="scss" scoped>
.switch {
  .slider {
    &:hover {
      border-color: $grey90 !important;
    }

    &:before {
      border-color: $grey90 !important;
    }
  }


}
</style>
